import React from 'react'

const Booking = () => {
  return (
    <div>Booking Section will be available soon.</div>
  )
}

export default Booking